import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GlobalService } from 'src/app/services/index.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})

export class ErrorComponent implements OnInit, OnDestroy{

  constructor(
    private route:ActivatedRoute,
    private globalSerivce:GlobalService
  ){}

  @Input() imgName:string | undefined | null = ''
  @Input() errorContent:string = ''
  @Input() errorStatus = 0;
  noInternetHeight:string = ''

  ngOnInit(): void {
    this.noInternetHeight = this.imgName=='net'?'h-[calc(100vh-3.5rem)]':''
    if(this.route.snapshot.data['picAddress']){
      this.imgName = this.route.snapshot.data['picAddress']
      this.errorContent = this.route.snapshot.data['errorContent']
      this.errorStatus = this.route.snapshot.data['errorStatus']
    }

    if(this.errorStatus==404){
      this.create404StatusForPrerendrer()
    }else{
      this.remove404StatusForPrerendrer()
    }
  }

  create404StatusForPrerendrer(){
    this.globalSerivce.createMetaTag("prerender-status-code","404")
  }

  remove404StatusForPrerendrer(){
    this.globalSerivce.removeMetaTag("prerender-status-code")
  }

  ngOnDestroy(): void {
    this.remove404StatusForPrerendrer()
  }
}
